import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "bmi-calc-height" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "btn-group ms-3" }
const _hoisted_7 = ["disabled", "onClick"]
const _hoisted_8 = { class: "form-check mt-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label item-body",
  for: "heightUnknown"
}, "I don't know my height", -1)
const _hoisted_11 = {
  key: 0,
  class: "row mt-1 item-validation-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["item-label", {'row': !_ctx.isSmallScreen}])
    }, _toDisplayString(_ctx.title), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["text-start item-font item-content text-muted mb-1", {'row': !_ctx.isSmallScreen}]),
      innerHTML: _ctx.prompt
    }, null, 10, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass({'row': !_ctx.isSmallScreen})
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["d-flex ps-0", {'full-width': _ctx.isSmallScreen}])
      }, [
        (_ctx.selectedUnit == 'M')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({'full-width': _ctx.isSmallScreen})
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.metres) = $event)),
                disabled: _ctx.inputDisable || _ctx.isDisabled,
                class: _normalizeClass(["item-content ins-form-control ps-2", { 'validation-error': _ctx.validationError }])
              }, null, 10, _hoisted_3), [
                [_vModelText, _ctx.metres]
              ])
            ], 2))
          : (_ctx.selectedUnit == 'Ft')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["d-flex", {'full-width': _ctx.isSmallScreen}])
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.feet) = $event)),
                  disabled: _ctx.inputDisable || _ctx.isDisabled,
                  class: _normalizeClass(["item-content ins-form-control-half ps-2", { 'validation-error': _ctx.validationError }]),
                  placeholder: "ft"
                }, null, 10, _hoisted_4), [
                  [_vModelText, _ctx.feet]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inches) = $event)),
                  disabled: _ctx.inputDisable || _ctx.isDisabled,
                  class: _normalizeClass(["item-content ins-form-control-half ms-2 ps-2", { 'validation-error': _ctx.validationError }]),
                  placeholder: "in"
                }, null, 10, _hoisted_5), [
                  [_vModelText, _ctx.inches]
                ])
              ], 2))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.units, (unit) => {
            return (_openBlock(), _createElementBlock("button", {
              key: unit.value,
              class: _normalizeClass(["btn radio-booster-blue item-content", { active: _ctx.selectedUnit == unit.value }]),
              style: {},
              disabled: _ctx.isDisabled,
              onClick: ($event: any) => (_ctx.clickEventHandler(unit))
            }, _toDisplayString(unit.text), 11, _hoisted_7))
          }), 128))
        ])
      ], 2),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          id: "heightUnknown",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.heightUnknown) = $event)),
          type: "checkbox",
          class: "form-check-input check-item me-2",
          disabled: _ctx.isDisabled
        }, null, 8, _hoisted_9), [
          [_vModelCheckbox, _ctx.heightUnknown]
        ]),
        _hoisted_10
      ])
    ], 2),
    (_ctx.validationError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.validationError), 1))
      : _createCommentVNode("", true)
  ]))
}